import { Link } from '@solidjs/router';
import { styled } from 'solid-styled-components';
import theme, { fontFamilyAtosBold } from '../../../../../style/theme';

export const StyledFirstLevelMenuItemLink = styled(Link)<{active: boolean}>`
    border-bottom: 1px solid ${theme.palette.primary};
    font-size: 1.8rem;
    color: ${p => p.active ? theme.palette.primary : theme.palette.darkGray};
    font-family: ${fontFamilyAtosBold};
    font-weight: 800;
    text-decoration: none;
    cursor: pointer;
    padding-bottom: 2rem;
    display: flex;
    gap: 0.5rem;

    &:hover {
        color: ${theme.palette.primary};

        svg {
            path {
                fill: ${theme.palette.primary};
            }
        }
    }
`;
